window.theme = window.theme || {};
theme.byoStickBar = function () {
  var $header = $('.js-byo-header');
  var $body = $('body');
  if($header.offset()){
    var oldScroll = 0;
    var initialByoOffset = 0;
    $(window).on("scroll", function(){
      var scrollTop = $(window).scrollTop();
      if(scrollTop > initialByoOffset) {
        $body.addClass('has-byo-fixed-top');
        $header.addClass('byo-header-sticky');
        if (oldScroll > scrollTop && ($header.hasClass('byo-with-menu') || oldScroll - scrollTop > 10)) {
          $header.addClass('byo-with-menu');
        } else {
          $header.removeClass('byo-with-menu');
        }
      } else {
        initialByoOffset = $header.offset().top;
        $body.removeClass('has-byo-fixed-top');
        $header.removeClass('byo-header-sticky');
        $header.removeClass('byo-with-menu');
      }
      oldScroll = scrollTop;
    }).trigger('scroll');
  }
};
